<template>
  <img v-if="icon" :src="icon" width="20px;" />
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import tablet from '@/apps/traforama/assets/icons/tablet.png'
import mobile from '@/apps/traforama/assets/icons/mobile.png'
import desktop from '@/apps/traforama/assets/icons/desktop.png'

const ICONS: Record<number, string> = {
  1: desktop,
  2: mobile,
  3: tablet
}

export default defineComponent({
  name: 'DeviceIcon',
  props: {
    deviceId: {
      type: Number,
      default: 1
    }
  },
  setup(props, context) {
    const icon = computed(() => {
      return ICONS[props.deviceId]
    })

    return { icon }
  }
})
</script>
